<template>
    <Fragment>
        <savedConfigDetailsVue v-if="configuration" :configuration="configuration" source="viewerApp"></savedConfigDetailsVue>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import { app } from "./application.js";
import savedConfigDetailsVue from "./components/configManagement/savedConfigDetails.vue";
import axios from 'axios';

export default {
    name: "viewerApp",
    props: {
        configurationId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            app,
            configuration: null
        };
    },
    methods: {
        refresh() {
            if (!this.configurationId) return

            const url = app.API.baseURL + '/configuration/load-employee/' + this.configurationId;
            axios({
                url: url,
                method: 'GET',
                withCredentials: true,
            }).then(response => {
                this.configuration = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    },

    created() {
    },

    mounted() {
        this.refresh()
    },

    destroyed() {
    },

    components: {
        Fragment,
        savedConfigDetailsVue
    }
};
</script>
